import { render, staticRenderFns } from "./AdminEstablishmentsMarketingCreditsModal.vue?vue&type=template&id=4c985056&scoped=true"
import script from "./AdminEstablishmentsMarketingCreditsModal.vue?vue&type=script&lang=js"
export * from "./AdminEstablishmentsMarketingCreditsModal.vue?vue&type=script&lang=js"
import style0 from "./AdminEstablishmentsMarketingCreditsModal.vue?vue&type=style&index=0&id=4c985056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c985056",
  null
  
)

export default component.exports